import { render, staticRenderFns } from "./SearchBeneficiaryExternalBenefits.vue?vue&type=template&id=86b816d6"
import script from "./SearchBeneficiaryExternalBenefits.vue?vue&type=script&lang=js"
export * from "./SearchBeneficiaryExternalBenefits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports